module.exports = ".loading-box {\n  border-width: 0px;\n  background-color: rgba(0, 0, 0, 0);\n  padding: 0px;\n  border-style: none none none;\n  border-color: rgba(0, 0, 0, 0); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/clickableBox/clickableBoxList.component.scss
// module id = ./src/app/components/common/clickableBox/clickableBoxList.component.scss
// module chunks = main